module.exports = __webpack_public_path__ + "img/device_1001_2_select.afa6698d.svg";